import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '@Hooks/index';
import { mrSelectAllManagerSelector } from '@Features/MaterialRequest/requests/MaterialRequisition/store/selectors/materialRequestSelector';

import { MaterialRequisitionItemFormResponse } from '@Types/api/form';
import { materialRequestActions } from '@Features/MaterialRequest/requests/MaterialRequisition/store/materialRequestSlice';

import styles from './material-list.module.css';
import MaterialItem from './components/MaterialItem';

interface MaterialListItemsProps {
  listItems: Array<MaterialRequisitionItemFormResponse>;
  onEditMaterialItem: (
    materialItemId: MaterialRequisitionItemFormResponse
  ) => void;
  onDeleteItem: (requisitionItem: Array<string | number>) => void;
}

const MaterialListItems: React.FC<MaterialListItemsProps> = ({
  listItems,
  onEditMaterialItem,
  onDeleteItem,
}) => {
  const dispatch = useAppDispatch();
  const { isSelected, selectedItems } = useAppSelector(
    mrSelectAllManagerSelector
  );

  const handleUnselectItem = useCallback(
    (reqItemId: number) => {
      dispatch(materialRequestActions.setMRUnselectItem(reqItemId));
    },
    [dispatch]
  );

  return (
    <div className={styles.container}>
      {listItems.map((matItem) => (
        <MaterialItem
          index={matItem.reqItemId}
          activityCode={matItem.actCode}
          activityId={matItem.actId}
          activityName={matItem.actName}
          materialDescription={matItem.matDesc}
          materialCode={matItem.matCode}
          materialId={matItem.matId}
          plantName={matItem.plantName}
          plantCode={matItem.plantCode}
          plantId={matItem.plantId}
          ledgerName={matItem.ledgerName}
          ledgerCode={matItem.ledgerCode}
          ledgerId={matItem.ledgerId}
          qty={matItem.reqQty}
          remarks={matItem.transferRemarks}
          resourceDescription={matItem.resDesc}
          resourceCode={matItem.resCode}
          unit={matItem.unitName}
          handleDeleteItem={() => onDeleteItem([matItem.reqItemId])}
          handleEditItem={() => onEditMaterialItem(matItem)}
          handleUnselectItem={() => handleUnselectItem(matItem.reqItemId)}
          repeatItem={matItem.repeatForAll}
          isSelected={isSelected}
          checkedItem={Boolean(
            selectedItems.find((item) => item === matItem.reqItemId)
          )}
          key={matItem.reqItemId}
        />
      ))}
    </div>
  );
};

export default MaterialListItems;
